import { httpPostAsPromise } from '../../../pages/domestic/domesticAuthHttp';

export const ACTIVE_USER_PAGE_LIMIT = 100;

type AuthOptions = {
  onTokenRefreshed?: (user: object) => void;
  onSessionExpired?: () => void;
};

export type OrgMatch = {
  organizationId: number;
  organizationName: string;
};

export type CpUser = {
  webId?: string;
  firstName?: string;
  lastName?: string;
};

type UserSearchResponse = {
  users?: CpUser[];
  pagination?: { totalRecords?: number };
};

/**
 * Organization typeahead used by Admin CP Search.
 * POST /mgmt/admin/cp/org with `{ org: "prefix%" }`.
 */
export function searchOrganizations(prefix: string, user: object, options?: AuthOptions) {
  const url = (global as { URL_AdminOrgLookUp?: string }).URL_AdminOrgLookUp;
  return httpPostAsPromise(url, { org: `${prefix}%` }, user, options).then((data) =>
    Array.isArray(data) ? (data as OrgMatch[]) : [],
  );
}

/**
 * Active users at an organization, via Admin CP Search.
 * POST /mgmt/admin/cp/user. Active only, first page.
 */
export function searchActiveUsers(orgId: number, user: object, options?: AuthOptions) {
  const url = (global as { URL_AdminProfileSearch?: string }).URL_AdminProfileSearch;
  return httpPostAsPromise(
    url,
    {
      orgId,
      firstName: '',
      lastName: '',
      isActive: true,
      isInActive: false,
      emailAddress: '',
      page: 1,
      pageLimit: ACTIVE_USER_PAGE_LIMIT,
    },
    user,
    options,
  ).then((data: UserSearchResponse) => {
    const users = Array.isArray(data?.users) ? data.users : [];
    const totalRecords = Number(data?.pagination?.totalRecords);
    return {
      users,
      totalRecords: Number.isFinite(totalRecords) ? totalRecords : users.length,
    };
  });
}
